<template>
  <v-container fluid>
    <v-row style="margin-top: 50px;">
      <v-col class="sidebar-col" style="max-width:180px;flex-basis:180px;">
        <v-list nav dense class="sidebar-list">
          <v-list-item :active="activeTab === 'users'" @click="activeTab = 'users'" class="sidebar-list-item">
            <v-list-item-icon>
              <v-icon color="primary">mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="sidebar-list-title">Użytkownicy</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col>
        <div v-if="activeTab === 'users'">
          <v-card class="mb-6 pa-3" height="50px" color="#FBDE3C" dark>
            <v-layout>
              <span
                class="ml-3 black--text font-weight-black"
                style="font-size: 1.3em"
                >Lista użytkowników</span
              >
            </v-layout>
          </v-card>
          <v-row class="mb-2">
            <v-col cols="auto">
              <v-btn color="primary" @click="openAddUser">Dodaj użytkownika</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="primary" :disabled="selected.length !== 1" @click="openEditUser(selectedUser)">Edytuj użytkownika</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="error" :disabled="selected.length !== 1" @click="openDeleteDialog">Usuń użytkownika</v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="userHeaders"
            :items="users"
            class="elevation-1 admin-users-table"
            :loading="loadingUsers"
            item-key="id"
            show-select
            v-model="selected"
          >
            <template v-slot:item.roleId="{ item }">
              {{ getRoleName(item.roleId) }}
            </template>
            <template v-slot:item.active="{ item }">
              <v-chip :color="item.active ? 'green' : 'red'" dark>{{ item.active ? 'Aktywny' : 'Nieaktywny' }}</v-chip>
            </template>
          </v-data-table>
          <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card>
              <v-card-title>Potwierdź usunięcie</v-card-title>
              <v-card-text>Czy na pewno chcesz usunąć użytkownika <strong>{{ selectedUser && selectedUser.username }}</strong>?</v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="error" @click="deleteUser">Usuń</v-btn>
                <v-btn text @click="deleteDialog = false">Anuluj</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="editDialog" max-width="500px">
            <v-card>
              <v-card-title>{{ isAddUser ? 'Dodaj użytkownika' : 'Edytuj użytkownika' }}</v-card-title>
              <v-card-text>
                <v-text-field v-model="editUser.username" label="Nazwa użytkownika" />
                <v-text-field v-model="editUser.email" label="E-mail" />
                <v-select v-model="editUser.roleId" :items="roleOptions" label="Rola" item-text="label" item-value="id" />
                <v-text-field v-if="isAddUser" v-model="editUser.password" label="Hasło" type="password" />
                <v-switch v-model="editUser.active" label="Aktywny" color="primary" />
                <v-btn v-if="!isAddUser" color="warning" @click="openResetPasswordDialog">Resetuj hasło</v-btn>
                        <v-dialog v-model="resetPasswordDialog" max-width="400px">
                          <v-card>
                            <v-card-title>Wpisz nowe hasło</v-card-title>
                            <v-card-text>
                              <v-text-field v-model="newPassword" label="Nowe hasło" type="password" />
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer />
                              <v-btn color="primary" @click="submitResetPassword">Zatwierdź</v-btn>
                              <v-btn text @click="closeResetPasswordDialog">Anuluj</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="isAddUser ? addUser() : saveUser()">Zapisz</v-btn>
                <v-btn text @click="closeDialog">Anuluj</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div v-if="activeTab === 'products'">
          <h2 class="mb-2">Lista produktów</h2>
          <v-data-table :headers="productHeaders" :items="products" class="elevation-1" :loading="loadingProducts" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { API_BASE_URL } from '../../services/api-url';
export default {
  name: "Admin",
  data() {
    return {
      activeTab: 'users',
      users: [],
      comments: [],
      loadingUsers: false,
      loadingComments: false,
      userHeaders: [
        { text: 'Nazwa użytkownika', value: 'username' },
        { text: 'E-mail', value: 'email' },
        { text: 'Rola', value: 'roleId' },
        { text: 'Aktywny', value: 'active' }
      ],
      editDialog: false,
      editUser: {
        username: '',
        email: '',
        roleId: 1,
        password: '',
        active: true
      },
      roleOptions: [
        { id: 1, label: 'Użytkownik' },
        { id: 2, label: 'Moderator' },
        { id: 3, label: 'Administrator' }
      ],
      selected: [],
      selectedUser: null,
      isAddUser: false,
      resetPasswordDialog: false,
      newPassword: '',
      deleteDialog: false
    };
  },
  methods: {
        openDeleteDialog() {
          this.deleteDialog = true;
        },
        deleteUser() {
          if (!this.selectedUser) return;
          axios.delete(`${API_BASE_URL}/api/admin/users/${this.selectedUser.id}`, {
            headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
          })
            .then(() => {
              this.deleteDialog = false;
              this.fetchUsers();
            });
        },
        openResetPasswordDialog() {
          this.newPassword = '';
          this.resetPasswordDialog = true;
        },
        closeResetPasswordDialog() {
          this.resetPasswordDialog = false;
          this.newPassword = '';
        },
        submitResetPassword() {
          if (!this.newPassword) {
            alert('Wpisz nowe hasło!');
            return;
          }
          axios.put(`${API_BASE_URL}/api/admin/users/${this.editUser.id}/reset-password`, { password: this.newPassword }, {
            headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
          })
            .then(() => {
              alert('Hasło zostało zresetowane!');
              this.closeResetPasswordDialog();
            });
        },
    openEditUser(user) {
      if (!user) return;
      this.isAddUser = false;
      this.editUser = { ...user };
      this.editDialog = true;
    },
    openAddUser() {
      this.isAddUser = true;
      this.editUser = { username: '', email: '', roleId: 1, password: '', active: true };
      this.editDialog = true;
    },
    closeDialog() {
      this.editDialog = false;
      this.editUser = { username: '', email: '', roleId: 1, password: '', active: true };
      this.isAddUser = false;
    },
    addUser() {
      axios.post(`${API_BASE_URL}/api/admin/users`, this.editUser, {
        headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
      })
        .then(() => {
          this.fetchUsers();
          this.closeDialog();
        });
    },
    getRoleName(roleId) {
      const role = this.roleOptions.find(r => r.id === roleId);
      return role ? role.label : 'Brak';
    },
    saveUser() {
      axios.put(`${API_BASE_URL}/api/admin/users/${this.editUser.id}`, this.editUser, {
        headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
      })
        .then(() => {
          this.fetchUsers();
          this.closeDialog();
        });
    },
    resetPassword() {
      axios.post(`${API_BASE_URL}/api/admin/users/${this.editUser.id}/reset-password`, {}, {
        headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
      })
        .then(() => {
          alert('Hasło zostało zresetowane!');
        });
    },
    fetchUsers() {
      this.loadingUsers = true;
      axios.get(`${API_BASE_URL}/api/admin/users`, {
        headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
      })
        .then(res => {
          this.users = res.data;
          // Reset selection after reload
          this.selected = [];
          this.selectedUser = null;
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },
    // produkty usunięte
    fetchComments() {
      this.loadingComments = true;
      axios.get(`${API_BASE_URL}/api/admin/comments`, {
        headers: { 'x-access-token': JSON.parse(localStorage.getItem('user')).accessToken }
      })
        .then(res => {
          this.comments = res.data;
        })
        .finally(() => {
          this.loadingComments = false;
        });
    }
  },
  watch: {
    activeTab(val) {
      if (val === 'users') this.fetchUsers();
      if (val === 'comments') this.fetchComments();
    },
    selected(val) {
      this.selectedUser = val.length ? val[0] : null;
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>

<style scoped>
  h1 {
    color: #1976d2;
  }
  .mb-2 {
    margin-bottom: 16px;
  }
  .mb-4 {
    margin-bottom: 32px;
  }
  .sidebar-col {
    border-right: 1px solid #eee;
    min-height: 500px;
    background: #fafafa;
    padding-top: 24px;
    padding-left: 0;
    padding-right: 0;
    box-shadow: 2px 0 8px -4px #e0e0e0;
  }
  .sidebar-list {
    background: transparent;
    padding: 0;
  }
  .sidebar-list-item {
    border-radius: 10px;
    margin: 6px 8px;
    transition: background 0.2s, box-shadow 0.2s;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: 500;
    box-shadow: 0 1px 4px -2px #bdbdbd;
    border: 1px solid #e0e0e0;
    background: #fff;
  }
  .sidebar-list-title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #222;
  }
  .sidebar-list-item.v-list-item--active {
    background: linear-gradient(90deg,#1976d2 80%,#42a5f5 100%) !important;
    color: #fff !important;
    box-shadow: 0 2px 12px -2px #1976d2;
    border: 1.5px solid #1976d2;
  }
  .sidebar-list-item.v-list-item--active .sidebar-list-title {
    color: #fff !important;
  }
  .sidebar-list-item:hover {
    background: #e3eafc;
    color: #1976d2;
    box-shadow: 0 2px 8px -2px #90caf9;
    border: 1.5px solid #90caf9;
  }
  .sidebar-list-item:hover .sidebar-list-title {
    color: #1976d2;
  }
  .admin-users-table {
    margin-bottom: 50px;
  }
</style>
